<!-- =========================================================================================
  File Name: DataListThumbView.vue
  Description: Data List - Thumb View
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
========================================================================================== -->

<template>
  <div id="data-list-thumb-view" class="data-list-container">
    <vx-card title="Equipamentos - Busca Pedidos por Produtos">
      <div class="vx-row">
        <div class="vx-col md:w-1/2 w-full mt-5">
          <h6 class="mb-2">Produtos</h6>
          <v-select
            :options="getProducts"
            label="label"
            v-model="product"
            name="product"
            v-validate="'required'"
          >
            <template slot="option" slot-scope="option">
              <img
                :src="option.image"
                width="40"
                height="40"
                class="rounded-full shadow-md cursor-pointer block"
              />
              {{ option.label }}
            </template>
          </v-select>
          <br />
          <span class="text-danger">{{ errors.first("product") }}</span>
        </div>
      </div>

   
     <div class="vx-row">
        <div class="vx-col md:w-1/2 w-full mt-5">
          <vs-button class="float-left" color="success" type="filled" @click="submit"
            >Buscar</vs-button
          >
        </div>
         
         <div class="vx-col md:w-1/2 w-full mt-5">
          <vs-button class="float-right" color="warning" type="filled" @click="clear"
            >Limpar</vs-button
          >
        </div>
     </div>
  
    </vx-card>
  
  </div>
</template>

<script>
import { Validator } from "vee-validate";
import vSelect from "vue-select";
import axios from "axios";
import { baseApiUrl } from "@/global";
const dict = {
  custom: {
    product: {
      required: "Selecione um Produto",
    },
  },
};
Validator.localize("en", dict);
export default {
  components: {
    vSelect,
  },
  data() {
    return {
      product: null,
      ordersResult :null,
    };
  },
  props: {},
  computed: {
    getProducts() {
      let products = _.cloneDeep(this.$store.state.products);
      products.forEach((element) => {
        element.id = element.idProduct;
        element.label = `${element.name} | ${element.code}`;
        element.image = element.photoProduct;
      });
      return products;
    },
  },
  methods: {
    async submit() {
      const haveErrors = !(await this.$validator.validateAll());
      console.log(haveErrors)
      if (haveErrors) return;
      let idProduct = this.product.idProduct;
      try {
        this.$vs.loading();
        let res = await axios.post(
          `${baseApiUrl}/equipmentOrder/getByIdProduct`,
          { idProduct }
        );
        this.ordersResult = res.data
        this.$emit("ordersResult", this.ordersResult);
      } catch (error) {
        if (!error.response || !error.response.data) return;
        this.$vs.notify({
          title: "Erro",
          text: error.response.data,
          iconPack: "feather",
          icon: "icon-alert-circle",
          color: "danger",
        });
      } finally {
        this.$vs.loading.close();
      }
    },
    async clear(){
     this.$emit("clear", true);
  },
  },
  async created() {
    let payload = {
      loading: this.$vs.loading,
    };
    await this.$store.dispatch("fetchProductsItems", payload);
  },
};
</script>

<style lang="scss">
</style>
